module.exports = __webpack_public_path__ + "a981afc0239ad89c243c88e7d4dd1224.svg";